import styled from 'particles/themes/styled'
import Modal from 'particles/Modal'

interface ModalContainerProps {
    isLoading?: boolean
}

export const ModalContainer = styled(Modal)<ModalContainerProps>`
    .close-button {
        cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[400]};
    }

    .button-group {
        display: flex;
        justify-content: flex-end;
        gap: ${({ theme }) => theme.spacing[600]};
        margin-top: 8px;
    }
`
